import { AsyncCustomersNav } from '@jira/navigation-apps__horizontal-nav-csm-customers/src/index.tsx';
import { l1CustomersProjectProviderResource } from '@jira/router-resources__customer-service-l1-customers-project-provider/src/l1CustomersProjectProviderResource.tsx';
import { csmCustomerContextTenantMigratedStatusResource } from '@jira/router-resources__service-desk-customer-service-customers-organizations-common/src/csmCustomerContextTenantMigratedStatusResource.tsx';
import { customerServiceCustomersEntryPoint } from '@jira/spa-apps__customer-service-customers/src/customerServiceCustomersEntryPoint.entrypoint.tsx';
import { customerServiceManagementCrmImportModuleResource } from '@jira/customer-service__forge-extensions/src/crm-import/customerServiceManagementCrmImportModuleResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { customerServiceCustomersRoute } from '@jira/router-routes__customer-services-customers-routes/src/customerServiceCustomersRoute.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const customerServiceCustomersPageEntryPoint = createPageEntryPoint({
	main: customerServiceCustomersEntryPoint,
});

export const customerServiceCustomersRouteEntry: Route = createEntry(
	customerServiceCustomersRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.customers',
		layout: globalLayout,
		navigation: {
			horizontal: AsyncCustomersNav,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint() {
			return customerServiceCustomersPageEntryPoint;
		},
		resources: [
			...getNavigationResources(),
			l1CustomersProjectProviderResource,
			csmCustomerContextTenantMigratedStatusResource,
			customerServiceManagementCrmImportModuleResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
